import { useState } from "react";
import Image from "next/image";
import classnames from "classnames";
import useBodyClass from "hooks/useBodyClass";
import GalleryCard from "components/global/gallery-card";
import styles from "./gallery.module.css";

export default function Gallery({ item, className, ...props }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState();

  const showModal = (image) => {
    window.scrollTo(0, 0);
    setModalImage(image);
    setModalOpen(true);
  };

  useBodyClass(modalOpen ? "overflow-hidden" : "overflow-auto");

  if (!item.MainPhoto && !item?.Gallery?.length) {
    return null;
  }

  return (
    <>
      <div className={className} {...props}>
        <div className="mb-10 overflow-hidden rounded-lg bg-white shadow">
          <div className="px-4 py-5 sm:p-6">
            <div className="mb-5 border-b border-gray-200 pb-5">
              <h3 className="flex-1 text-2xl font-bold text-gray-900">
                Gallery
              </h3>
            </div>

            <div className="grid grid-cols-2 gap-8 last:mb-0 md:grid-cols-2 lg:grid-cols-4">
              <GalleryCard showModal={showModal} image={item.MainPhoto} />

              {item?.Gallery?.map((image, index) => (
                <GalleryCard
                  showModal={showModal}
                  image={image}
                  key={`Gallery-${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className={classnames(
          "absolute top-0 left-0 z-20 h-screen w-screen overflow-hidden bg-gray-900 bg-opacity-95 p-8",
          { hidden: !modalOpen }
        )}
        onClick={() => setModalOpen(false)}
        onKeyPress={(e) => {
          if (e.key === "Escape") {
            setModalOpen(false);
          }
        }}
        role="button"
        aria-label="Close"
        tabIndex={0}
      >
        {modalImage && (
          <figure className="relative h-full w-full">
            <Image
              src={`https://images.opencoaster.com/1600x/${modalImage.hash}${modalImage.ext}`}
              alt={modalImage.alternativeText}
              layout="fill"
              // height={modalImage.height}
              // width={modalImage.width}
              unoptimized
              className="object-contain"
            />
            <figcaption
              className={classnames(
                "absolute bottom-0 right-0 p-1 font-mono text-white text-opacity-75",
                styles.caption
              )}
            >
              {modalImage.caption}
            </figcaption>
          </figure>
        )}
      </div>
    </>
  );
}